export const leftMenu = {
  "Deseja voltar da pausa:": "Do you want to return from break:",
  "Tempo total em pausa:": "Total break time:",
  "Selecione o motivo da pausa": "Select the reason for the break",
  "Marcar Ponto": "Mark Time",
  "Marcar Pausa": "Start Break",
  "Em Pausa": "On Break",
  "Voltar da pausa": "Return from break",
  "Cancelar": "Cancel",
  "Confirmar pausa": "Confirm break",
  "Marcar pausa": "Start break",
  "Início": "Home",
  "Lembretes": "Reminders",
  "Gestão de tarefas": "Task Management",
  "Comunicados": "Statements",
  "Documentos": "Documents",
  "Feedbacks": "Feedback",
  "Reuniões 1:1": "1:1 Meetings",
  "Reembolsos": "Reimbursements",
  "Saldo de horas": "Time Balance",
  "Solicitações de ajuste": "Adjustment Requests",
  "Férias/Afastamento": "Vacation and Absence",
  "Histórico de Ponto": "Time Record History",
  "Espelhos de Ponto": "Time Record Statements",
  "Log de Registros": "Record Log",
  "Modo ponto": "Time Mode",
  "Minha equipe": "My Team",
  "Gestão de Ponto": "Time Management",
  "Gerenciar afastamentos": "Manage Absences",
  "Solicitações da equipe": "Team Requests",
  "Sobreaviso": "On-call",
  "Modo escuro": "Dark Mode",
  "Modo claro": "Light Mode",
  "Meu perfil": "My Profile",
  "Ouvidoria": "Whistleblowing",
  "Política de privacidade": "Privacy policy",
  "Sair": "Logout"
};


// WEBPACK FOOTER //
// ./src/resources/enUS/leftMenu.js